import assetPath from '/app/packages/lebenslauf/constants/src/assets/template-4.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')